import { mdiAlertCircle } from '@mdi/js';
import * as React from 'react';
import { validateLatin1String } from '../../../utils';
import * as S from './area.styles';

export interface IBaseAreaProps extends Omit<React.PropsWithoutRef<JSX.IntrinsicElements['textarea']>, 'children'> {
    /**
     * If true, disables Latin-1 character validation for this textarea.
     * By default, all textareas validate for Latin-1 encoded characters on blur.
     */
    disableLatin1Validation?: boolean;
    /**
     * Optional error message to display below the textarea.
     */
    errorMessage?: string;
}

interface IBaseAreaState {
    latin1ValidationError: string | null;
}

export class BaseArea extends React.Component<IBaseAreaProps, IBaseAreaState> {
    constructor(props: IBaseAreaProps) {
        super(props);
        this.state = {
            latin1ValidationError: null,
        };
    }

    private handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>): void => {
        const { onBlur, disableLatin1Validation } = this.props;
        
        if (!disableLatin1Validation) {
            const value = e.target.value;
            const validationResult = validateLatin1String(value);
            
            this.setState({
                latin1ValidationError: validationResult.isValid ? null : validationResult.errorMessage || null,
            });
        }
        
        onBlur?.(e);
    };

    public render(): React.ReactElement {
        const { disableLatin1Validation, errorMessage, onBlur, ...props } = this.props;
        const { latin1ValidationError } = this.state;

        const displayError = errorMessage || latin1ValidationError;

        return (
            <S.AreaWrapper>
                <S.AreaContainer 
                    {...props} 
                    onBlur={this.handleBlur}
                    showError={!!displayError}
                />
                {displayError && (
                    <S.AreaError>
                        <S.AreaErrorIcon path={mdiAlertCircle} size={0.7} />
                        <S.AreaErrorMessage>{displayError}</S.AreaErrorMessage>
                    </S.AreaError>
                )}
            </S.AreaWrapper>
        );
    }
}
